(function () {
  var configEl = document.getElementById("gc-config");
  if (!configEl) return;

  var config = {};
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

  var banner      = document.getElementById("gc-banner");
  var overlay     = document.getElementById("gc-overlay");
  var modal       = document.getElementById("gc-modal");
  var btnAccept   = document.getElementById("gc-btn-accept");
  var btnPrefs    = document.getElementById("gc-btn-preferences");
  var btnSave     = document.getElementById("gc-btn-save");
  var modalClose  = document.getElementById("gc-modal-close");
  var policyLink  = document.getElementById("gc-policy-link");
  var modalPolicy = document.getElementById("gc-modal-policy-link");
  var togAnalytics  = document.getElementById("gc-toggle-analytics");
  var togMarketing  = document.getElementById("gc-toggle-marketing");
  var togPrefs      = document.getElementById("gc-toggle-preferences");

  if (!banner || !btnAccept) return;

  if (policyLink)  policyLink.href  = config.privacyUrl || "#";
  if (modalPolicy) modalPolicy.href = config.privacyUrl || "#";

  // ── Google Consent Mode v2 ────────────────────────────────────────────────

  function pushDataLayer(obj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
  }

  function googleConsentDefault() {
    // Must fire before GTM loads — sets privacy-first defaults
    pushDataLayer(["consent", "default", {
      ad_storage:             "denied",
      ad_personalization:     "denied",
      ad_user_data:           "denied",
      analytics_storage:      "denied",
      functionality_storage:  "denied",
      personalization_storage:"denied",
      security_storage:       "granted",
      wait_for_update:        1500
    }]);
  }

  function googleConsentUpdate(analytics, marketing, preferences) {
    pushDataLayer(["consent", "update", {
      ad_storage:             marketing  ? "granted" : "denied",
      ad_personalization:     marketing  ? "granted" : "denied",
      ad_user_data:           marketing  ? "granted" : "denied",
      analytics_storage:      analytics  ? "granted" : "denied",
      functionality_storage:  preferences ? "granted" : "denied",
      personalization_storage:preferences ? "granted" : "denied",
      security_storage:       "granted"
    }]);
  }

  // ── Shopify Customer Privacy API ──────────────────────────────────────────

  function shopifyConsentUpdate(analytics, marketing, preferences) {
    var consent = { analytics: analytics, marketing: marketing, preferences: preferences };
    if (window.Shopify && window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.setTrackingConsent === "function") {
      window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {});
    } else {
      document.addEventListener("shopify:consent:ready", function () {
        window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {});
      });
    }
  }

  // ── localStorage flag (instant, survives navigation before Shopify cookie sets) ──

  var LS_KEY = "gc_consent_given";

  function markConsentGiven() {
    try { localStorage.setItem(LS_KEY, "1"); } catch (e) {}
  }

  function hasLocalConsent() {
    try { return localStorage.getItem(LS_KEY) === "1"; } catch (e) { return false; }
  }

  // ── Apply consent (both APIs at once) ────────────────────────────────────

  function applyConsent(analytics, marketing, preferences) {
    markConsentGiven();
    googleConsentUpdate(analytics, marketing, preferences);
    shopifyConsentUpdate(analytics, marketing, preferences);
  }

  // ── Banner show / hide ────────────────────────────────────────────────────

  function showBanner() {
    banner.style.display = "block";
    void banner.offsetWidth;
    banner.classList.add("gc-visible");
    bindScrollAccept();
  }

  function hideBanner() {
    banner.style.display = "none";
    unbindScrollAccept();
  }

  // ── Scroll = accept ───────────────────────────────────────────────────────

  var scrollFired = false;

  function onScroll() {
    if (scrollFired) return;
    if (window.scrollY > 50) {
      scrollFired = true;
      unbindScrollAccept();
      hideBanner();
      applyConsent(true, true, true);
    }
  }

  function bindScrollAccept() {
    scrollFired = false;
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function unbindScrollAccept() {
    window.removeEventListener("scroll", onScroll);
  }

  // ── Modal ─────────────────────────────────────────────────────────────────

  function setToggle(input, on) {
    if (!input) return;
    input.checked = on;
    var key = input.id.replace("gc-toggle-", "");
    var track = modal.querySelector(".gc-track[data-key='" + key + "']");
    var thumb = modal.querySelector(".gc-thumb[data-key='" + key + "']");
    if (track) track.style.background = on ? "#2a7a2a" : "#ccc";
    if (thumb) thumb.style.left = on ? "21px" : "3px";
  }

  function bindToggle(input) {
    if (!input) return;
    input.addEventListener("change", function () { setToggle(input, input.checked); });
  }

  bindToggle(togAnalytics);
  bindToggle(togMarketing);
  bindToggle(togPrefs);

  function openModal() {
    // Pre-fill with current consent state, default all on if unknown
    var analytics = true, marketing = true, preferences = true;
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        var existing = window.Shopify.customerPrivacy.getTrackingConsent();
        if (existing !== "" && existing !== "no_interaction") {
          var c = window.Shopify.customerPrivacy.currentVisitorConsent();
          analytics   = c.analytics   !== "no";
          marketing   = c.marketing   !== "no";
          preferences = c.preferences !== "no";
        }
      }
    } catch (e) {}
    setToggle(togAnalytics,  analytics);
    setToggle(togMarketing,  marketing);
    setToggle(togPrefs,      preferences);
    overlay.style.display = "block";
    modal.style.display   = "block";
  }

  function closeModal() {
    overlay.style.display = "none";
    modal.style.display   = "none";
  }

  // ── Consent check ─────────────────────────────────────────────────────────

  function consentAlreadyGiven() {
    if (hasLocalConsent()) return true;
    try {
      return window.Shopify &&
             window.Shopify.customerPrivacy &&
             !window.Shopify.customerPrivacy.shouldShowBanner();
    } catch (e) { return false; }
  }

  // ── Event listeners ───────────────────────────────────────────────────────

  btnAccept.addEventListener("click", function () {
    hideBanner();
    closeModal();
    applyConsent(true, true, true);
  });

  btnPrefs.addEventListener("click", function () {
    openModal();
  });

  modalClose.addEventListener("click", closeModal);
  overlay.addEventListener("click", closeModal);

  btnSave.addEventListener("click", function () {
    var analytics   = togAnalytics ? togAnalytics.checked   : true;
    var marketing   = togMarketing ? togMarketing.checked   : true;
    var preferences = togPrefs     ? togPrefs.checked       : true;
    hideBanner();
    closeModal();
    applyConsent(analytics, marketing, preferences);
  });

  // ── Init ──────────────────────────────────────────────────────────────────

  // Google Consent Mode default must fire as early as possible
  googleConsentDefault();

  function init() {
    if (consentAlreadyGiven()) {
      // Returning visitor — restore consent signals to GTM without showing banner
      try {
        var c = window.Shopify.customerPrivacy.currentVisitorConsent();
        googleConsentUpdate(c.analytics !== "no", c.marketing !== "no", c.preferences !== "no");
      } catch (e) {
        googleConsentUpdate(true, true, true);
      }
    } else {
      showBanner();
    }
  }

  // Wait for Shopify's Customer Privacy API to be ready
  function waitForShopify() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      init();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (e) {
        if (!e) init();
      });
    } else {
      // Fallback poll
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        if (window.Shopify && window.Shopify.customerPrivacy) {
          clearInterval(poll);
          init();
        } else if (attempts > 30) {
          clearInterval(poll);
          showBanner(); // show anyway — better than never showing
        }
      }, 100);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitForShopify);
  } else {
    waitForShopify();
  }
})();
